import { render, staticRenderFns } from "./scrm.vue?vue&type=template&id=5ea9217f&scoped=true&"
import script from "./scrm.vue?vue&type=script&lang=js&"
export * from "./scrm.vue?vue&type=script&lang=js&"
import style0 from "./scrm.vue?vue&type=style&index=0&id=5ea9217f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9217f",
  null
  
)

export default component.exports